export default function Marquee() {
  const phrase = "Data driven aviation · Trusted worldwide ·";
  return (
    <section data-testid="marquee-section" className="py-16 md:py-24 border-t border-b border-[#0E1B2E]/10 bg-white overflow-hidden">
      <div className="flex whitespace-nowrap marquee-track">
        {Array.from({ length: 8 }).map((_, i) => (
          <span
            key={i}
            className={`font-serif italic tracking-[-0.02em] text-[80px] md:text-[140px] leading-none px-8 ${i % 2 === 0 ? "text-[#0E1B2E]" : "text-stroke-gold"}`}
          >
            {phrase}
          </span>
        ))}
      </div>
    </section>
  );
}
